module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_ID.e8e17317.jpg";